
import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import styled from 'styled-components';


const StyledTable = styled(Table)`
  td {
    vertical-align: top;
  }

  @media (max-width: 767px) {
    display: block;
    width: 100%;

    thead {
      display: none;
    }

    tbody tr {
      display: block;
      padding: 12px 16px;
      border-bottom: 1px solid #EDEDED;
    }

    tbody td {
      display: grid;
      grid-template-columns: 120px minmax(0, 1fr);
      align-items: start;
      gap: 8px;
      border: none;
      padding: 4px 0;
      min-width: 0;
      white-space: normal;
      overflow-wrap: anywhere;

      &:before {
        content: attr(data-label);
        grid-column: 1;
        grid-row: 1;
        color: #828282;
        font-size: 12px;
        line-height: 20px;
        padding-top: 2px;
      }

      > * {
        grid-column: 2;
        min-width: 0;
      }

      &:empty {
        display: none;
      }

      &[colspan] {
        display: block;
        grid-template-columns: none;
        padding: 8px 0;

        &:before {
          display: none;
        }
      }

      &:not([data-label]),
      &[data-label=""] {
        display: block;
        grid-template-columns: none;
      }

      &:not([data-label]):before,
      &[data-label=""]:before {
        display: none;
      }

      &.full-row-mobile {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        width: 100%;
        padding-top: 10px;

        &:before {
          display: block;
        }

        > * {
          grid-column: auto;
          width: 100%;
        }
      }
    }

    tfoot td {
      padding-left: 16px;
      padding-right: 16px;
    }

    thead .hide-on-mobile,
    tbody .hide-on-mobile,
    tbody td[data-label="#"] {
      display: none !important;
    }
  }
`;


function getHeaderLabels(table) {
  const headerRow = table.querySelector('thead tr');
  if (!headerRow) {
    return [];
  }
  return Array.from(headerRow.children).map((cell) => (
    (cell.innerText || '').replace(/\s+/g, ' ').trim()
  ));
}


function syncLabels(table) {
  if (!table || table.tagName !== 'TABLE') {
    return;
  }

  const labels = getHeaderLabels(table);
  table.querySelectorAll('tbody tr').forEach((row) => {
    const cells = Array.from(row.children).filter((el) => (
      el.tagName === 'TD' || el.tagName === 'TH'
    ));
    let index = 0;
    cells.forEach((cell) => {
      const colSpan = Number(cell.getAttribute('colspan') || 1);
      if (colSpan > 1) {
        cell.removeAttribute('data-label');
        index += colSpan;
        return;
      }
      const label = labels[index] || '';
      if (label) {
        cell.setAttribute('data-label', label);
      } else {
        cell.removeAttribute('data-label');
      }
      index += 1;
    });
  });
}


export class ResponsiveTable extends Component {

  tableRef = React.createRef();

  componentDidMount() {
    this.sync();
  }

  componentDidUpdate() {
    this.sync();
  }

  sync = () => {
    syncLabels(this.tableRef.current);
  };

  render() {
    return (
      <StyledTable ref={this.tableRef} {...this.props} />
    );
  }
}


export default ResponsiveTable;
